/*
 * @Author: songjingyang songjingyang@meishubao.com
 * @Date: 2025-03-28 15:40:04
 * @LastEditors: songjingyang songjingyang@meishubao.com
 * @LastEditTime: 2025-03-28 15:40:39
 * @FilePath: src/utils/auth.ts
 * @Description: TypeScript版本 - 自动转换
 */

import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken(): any {
  return Cookies.get(TokenKey)
}

export function setToken(token: any): any {
  return Cookies.set(TokenKey, token)
}

export function removeToken(): any {
  return Cookies.remove(TokenKey)
}
